import React, { useState, useEffect } from 'react';
import '../adminpanel/FaqManager.css'; 

const ContactManagement = ({ BASE_URL }) => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);

  const makeApiCall = async (method, url, successMsg) => {
    setLoading(true);
    setMessage('');
    setError(null);
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'accept': '*/*',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to ${method.toLowerCase()} contact. Status: ${response.status}`);
      }

      setMessage(successMsg);
      setEmail('');
      setPhone('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddContact = (e) => {
    e.preventDefault();
    if (!email || !phone) {
      setError('Email and Phone are required.');
      return;
    }
    const url = `${BASE_URL}/contact/add?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}`;
    makeApiCall('POST', url, 'Contact details added successfully!');
  };

  const handleUpdateContact = (e) => {
    e.preventDefault();
    if (!email || !phone) {
      setError('Email and Phone are required to update.');
      return;
    }
    const url = `${BASE_URL}/contact/update?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}`;
    makeApiCall('PUT', url, 'Contact details updated successfully!');
  };
return (
  <div className="admin-section-container">
    <h3 className="admin-section-heading">Contact Management</h3>

    {message && <p className="admin-success-message">{message}</p>}
    {error && <p className="admin-error-message">Error: {error}</p>}

    <form>
      <input
        className="admin-input"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        required
      />
      <input
        className="admin-input"
        type="tel"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="Phone"
        required
      />
      <div className="admin-action-buttons">
        <button
          type="button"
          onClick={handleAddContact}
          disabled={loading}
          className="admin-btn add"
        >
          {loading ? 'Adding...' : 'Add Contact'}
        </button>
        <button
          type="button"
          onClick={handleUpdateContact}
          disabled={loading}
          className="admin-btn update"
        >
          {loading ? 'Updating...' : 'Update Contact'}
        </button>
      </div>
    </form>
  </div>
);

};

const FaqManager = () => {
  const [faqs, setFaqs] = useState([]);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BASE_URL = 'https://heastro.in/heastro-service'; 
  const FAQ_URL = `${BASE_URL}/faqs`;

  const fetchFaqs = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(FAQ_URL);
      if (!response.ok) {
        throw new Error('Failed to fetch FAQs.');
      }
      const data = await response.json();
      setFaqs(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleAddFaq = async (e) => {
    e.preventDefault();
    if (!question || !answer) return;

    setLoading(true);
    setError(null);
    try {
      const url = `${FAQ_URL}/add-faq?question=${encodeURIComponent(question)}&answer=${encodeURIComponent(answer)}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'accept': '*/*',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to add FAQ.');
      }
      setQuestion('');
      setAnswer('');
      fetchFaqs();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateFaq = async (e) => {
    e.preventDefault();
    if (!question || !answer || !editingId) return;

    setLoading(true);
    setError(null);
    try {
      const url = `${FAQ_URL}/${editingId}?question=${encodeURIComponent(question)}&answer=${encodeURIComponent(answer)}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'accept': '*/*',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to update FAQ.');
      }
      setQuestion('');
      setAnswer('');
      setEditingId(null);
      fetchFaqs();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFaq = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${FAQ_URL}/${id}`, {
        method: 'DELETE',
        headers: {
          'accept': '*/*',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete FAQ.');
      }
      fetchFaqs();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const startEditing = (faq) => {
    setEditingId(faq.id);
    setQuestion(faq.question);
    setAnswer(faq.answer);
  };

  const cancelEditing = () => {
    setEditingId(null);
    setQuestion('');
    setAnswer('');
  };

  // return (
  //   <div className="admin-panel-container">
  //     <h2>FAQ & Contact Admin</h2>
  //     <ContactManagement BASE_URL={BASE_URL} />
  //     <hr />
      
  //     <div className="section-container">
  //       <h3>FAQ Management</h3>
  //       {error && <p className="error-message">Error: {error}</p>}
        
  //       <div className="faq-form-container">
  //         <h3>{editingId ? 'Edit FAQ' : 'Add New FAQ'}</h3>
  //         <form onSubmit={editingId ? handleUpdateFaq : handleAddFaq}>
  //           <input
  //             type="text"
  //             value={question}
  //             onChange={(e) => setQuestion(e.target.value)}
  //             placeholder="Question"
  //             required
  //           />
  //           <textarea
  //             value={answer}
  //             onChange={(e) => setAnswer(e.target.value)}
  //             placeholder="Answer"
  //             required
  //           />
  //           <div className="form-buttons">
  //             <button type="submit" disabled={loading}>
  //               {loading ? 'Processing...' : (editingId ? 'Update FAQ' : 'Add FAQ')}
  //             </button>
  //             {editingId && (
  //               <button type="button" onClick={cancelEditing} disabled={loading}>
  //                 Cancel
  //               </button>
  //             )}
  //           </div>
  //         </form>
  //       </div>
  //       <hr />
  //       <div className="faq-list-container">
  //         <h3>Existing FAQs</h3>
  //         {loading && !faqs.length ? (
  //           <p>Loading FAQs...</p>
  //         ) : (
  //           <ul className="faq-list">
  //             {faqs.map((faq) => (
  //               <li key={faq.id} className="faq-items">
  //                 <div className="faq-content">
  //                   <h4>{faq.question}</h4>
  //                   <p>{faq.answer}</p>
  //                 </div>
  //                 <div className="faq-actions">
  //                   <button onClick={() => startEditing(faq)}>Edit</button>
  //                   <button onClick={() => handleDeleteFaq(faq.id)}>Delete</button>
  //                 </div>
  //               </li>
  //             ))}
  //           </ul>
  //         )}
  //       </div>
  //     </div>
  //   </div>
  // );
  return (
  <div className="admin-panel-container">
    <h2 className="admin-panel-heading">FAQ & Contact Admin</h2>

    <ContactManagement BASE_URL={BASE_URL} />

    <hr className="admin-hr" />

    <div className="admin-section-container">
      <h3 className="admin-section-heading">FAQ Management</h3>

      {error && <p className="admin-error-message">Error: {error}</p>}

      <div className="admin-faq-form-container">
        <h3 className="admin-subheading">{editingId ? 'Edit FAQ' : 'Add New FAQ'}</h3>

        <form onSubmit={editingId ? handleUpdateFaq : handleAddFaq}>
          <input
            className="admin-input"
            type="text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Question"
            required
          />
          <textarea
            className="admin-textarea"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            placeholder="Answer"
            required
          />
          <div className="admin-form-buttons">
            <button
              type="submit"
              className="admin-btn update"
              disabled={loading}
            >
              {loading ? 'Processing...' : (editingId ? 'Update FAQ' : 'Add FAQ')}
            </button>
            {editingId && (
              <button
                type="button"
                className="admin-btn cancel"
                onClick={cancelEditing}
                disabled={loading}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <hr className="admin-hr" />

      <div className="admin-faq-list-container">
        <h3 className="admin-section-heading">Existing FAQs</h3>

        {loading && !faqs.length ? (
          <p>Loading FAQs...</p>
        ) : (
          <ul className="admin-faq-list">
            {faqs.map((faq) => (
              <li key={faq.id} className="admin-faq-item">
                <div className="admin-faq-content">
                  <h4>{faq.question}</h4>
                  <p>{faq.answer}</p>
                </div>
                <div className="admin-faq-actions">
                  <button
                    className="admin-btn update"
                    onClick={() => startEditing(faq)}
                  >
                    Edit
                  </button>
                  <button
                    className="admin-btn delete"
                    onClick={() => handleDeleteFaq(faq.id)}
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  </div>
);

};

export default FaqManager;